
<app-date-time id="{{getFieldName()}}" [formControl]="field" [no_time]="no_time"
               [ngClass]="{ 'is-invalid': submitted && field && field.errors }"></app-date-time>

<app-form-error [field]="field" [submitted]="submitted"></app-form-error>